/* Build a Bundle — runs the drawer: the bar, pills, item rows, and summary. */
(function () {
  'use strict';

  /* Mobile bar — item count + which step is still missing */

  function getTotalQty(state) {
    return ['harnesses', 'dildos', 'addons'].reduce((sum, step) => {
      return sum + state[step].reduce((s, item) => s + item.qty, 0);
    }, 0);
  }

  // Which "still need a…" message to show, or null once both required steps are filled.
  function getRequirementVariant(state) {
    const missingHarness = state.harnesses.length === 0;
    const missingDildo = state.dildos.length === 0;
    if (missingHarness && missingDildo) return 'both';
    if (missingHarness) return 'harness';
    if (missingDildo) return 'dildo';
    return null;
  }

  function syncBar() {
    const bar = document.querySelector('.js-bundle-bar');
    if (!bar) return;

    const state = window.BuildABundleState.getState();

    const countEl = bar.querySelector('.js-bundle-bar-count');
    if (countEl) countEl.textContent = String(getTotalQty(state));

    const messagesEl = bar.querySelector('.js-bundle-bar-messages');
    if (!messagesEl) return;

    const variant = getRequirementVariant(state);
    const allMessages = messagesEl.querySelectorAll('.build-a-bundle__bar-message');
    allMessages.forEach((el) => { el.hidden = true; });

    if (variant) {
      const target = messagesEl.querySelector('.js-bundle-bar-message-' + variant);
      if (target) target.hidden = false;
      messagesEl.hidden = false;
    } else {
      messagesEl.hidden = true;
    }
  }

  /* Drawer open / close
     closeDrawerIfOpen is captured by initDrawerToggle so the summary CTA
     can close the drawer on a successful ATC. */

  let closeDrawerIfOpen = null;

  function initDrawerToggle() {
    const drawer = document.querySelector('.js-bundle-drawer');
    if (!drawer) return;
    const toggle = drawer.querySelector('.js-bundle-bar-toggle');
    const body = drawer.querySelector('.build-a-bundle__drawer-body');
    const overlay = document.querySelector('.js-bundle-drawer-overlay');
    if (!toggle || !body) return;

    const labelExpand = toggle.dataset.labelExpand || toggle.getAttribute('aria-label');
    const labelCollapse = toggle.dataset.labelCollapse || labelExpand;

    // Open by growing from 0 to full height, then let it size itself.
    function openDrawer() {
      drawer.dataset.open = 'true';
      if (overlay) overlay.dataset.open = 'true';
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', labelCollapse);

      window.wfhDrawer.lockScroll();

      body.style.height = body.scrollHeight + 'px';
      // Always open at the top of the list
      body.scrollTop = 0;

      const onEnd = (e) => {
        if (e.target !== body || e.propertyName !== 'height') return;
        body.style.height = 'auto';
        body.removeEventListener('transitionend', onEnd);
      };
      body.addEventListener('transitionend', onEnd);
    }

    // Lock in the current height, then animate it down to 0 so it collapses smoothly.
    function closeDrawer() {
      body.style.height = body.scrollHeight + 'px';
      void body.offsetHeight;
      body.style.height = '0';

      drawer.dataset.open = 'false';
      if (overlay) overlay.dataset.open = 'false';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', labelExpand);

      window.wfhDrawer.unlockScroll();
    }

    closeDrawerIfOpen = () => {
      if (drawer.dataset.open === 'true') closeDrawer();
    };

    toggle.addEventListener('click', () => {
      if (drawer.dataset.open === 'true') closeDrawer();
      else openDrawer();
    });

    // Click-outside via the overlay closes the drawer.
    if (overlay) {
      overlay.addEventListener('click', () => {
        if (drawer.dataset.open === 'true') closeDrawer();
      });
    }

    // ESC closes when the bundle drawer is the active modal.
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.dataset.open === 'true') closeDrawer();
    });

    // Navigating between steps should close the drawer.
    document.addEventListener('build-a-bundle:step-changed', () => {
      if (drawer.dataset.open === 'true') closeDrawer();
    });
  }

  /* Drawer pills — banner version of the stepper indicator.
     state-changed writes data-state; step-changed writes data-active. */

  const REQUIRED_PILL_STEPS = ['harnesses', 'dildos'];

  function computePillState(step, hasItems) {
    if (hasItems) return 'added';
    return REQUIRED_PILL_STEPS.includes(step) ? 'required' : 'optional';
  }

  function syncDrawerPills() {
    const pills = document.querySelectorAll('.js-bundle-drawer-pill');
    if (pills.length === 0) return;

    const state = window.BuildABundleState.getState();

    pills.forEach((pill) => {
      const step = pill.dataset.step;
      const items = state[step] || [];
      const totalQty = items.reduce((sum, item) => sum + item.qty, 0);

      pill.dataset.state = computePillState(step, items.length > 0);

      const countEl = pill.querySelector('.js-bundle-drawer-pill-count');
      if (countEl) countEl.textContent = String(totalQty);

      const empty = document.querySelector(
        '.js-bundle-drawer-step-empty[data-step="' + step + '"]'
      );
      if (empty) empty.hidden = items.length > 0;
    });
  }

  function syncDrawerPillActive(activeStep) {
    document.querySelectorAll('.js-bundle-drawer-pill').forEach((pill) => {
      pill.dataset.active = pill.dataset.step === activeStep ? 'active' : 'inactive';
    });
  }

  function initDrawerPills() {
    if (!document.querySelector('.js-bundle-drawer-pill')) return;

    if (window.BuildABundleState) {
      syncDrawerPills();
      window.BuildABundleState.subscribe('build-a-bundle:state-changed', syncDrawerPills);
    } else {
      document.addEventListener(
        'build-a-bundle:hydrated',
        () => {
          syncDrawerPills();
          window.BuildABundleState.subscribe('build-a-bundle:state-changed', syncDrawerPills);
        },
        { once: true }
      );
    }

    // Initial paint from whichever stepper indicator is currently active.
    const initialActive = document.querySelector(
      '.js-bundle-step-indicator[data-active="active"]'
    );
    if (initialActive) syncDrawerPillActive(initialActive.dataset.step);

    document.addEventListener('build-a-bundle:step-changed', (e) => {
      if (e && e.detail && e.detail.step) syncDrawerPillActive(e.detail.step);
    });
  }

  function initBar() {
    const bar = document.querySelector('.js-bundle-bar');
    if (!bar) return;

    if (window.BuildABundleState) {
      syncBar();
      window.BuildABundleState.subscribe('build-a-bundle:state-changed', syncBar);
    } else {
      document.addEventListener(
        'build-a-bundle:hydrated',
        () => {
          syncBar();
          window.BuildABundleState.subscribe('build-a-bundle:state-changed', syncBar);
        },
        { once: true }
      );
    }
  }

  /* Item rows — clone the <template> for each item, rebuilt per step */

  // cents -> formatted money string using the shop's money format.
  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    const amountNoDecimals = Math.round(cents / 100).toString();
    const format =
      (window.__NOVA_GLOBAL__ && window.__NOVA_GLOBAL__.moneyFormat) || '${{amount}}';

    return format
      .replace('{{amount}}', addCommas(amount))
      .replace('{{amount_no_decimals}}', addCommas(amountNoDecimals))
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace(
        '{{amount_no_decimals_with_comma_separator}}',
        amountNoDecimals.replace(/(\d)(?=(\d{3})+$)/g, '$1.')
      );
  }

  function addCommas(str) {
    const parts = str.split('.');
    parts[0] = parts[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
    return parts.join('.');
  }

  function buildItemRow(item, step) {
    const tpl = document.querySelector('.js-bundle-item-row-template');
    const row = tpl.content.firstElementChild.cloneNode(true);

    row.dataset.variantId = item.variantId;
    row.dataset.step = step;

    const img = row.querySelector('.js-bundle-item-image');
    img.src = item.image;
    img.alt = item.title;

    row.querySelector('.js-bundle-item-title').textContent = item.title;

    // Line total (unit × qty), discounted + % off when complete.
    const S = window.BuildABundleState;
    const complete = S.isComplete();
    const linePrice = S.getItemDiscountedPrice(item) * item.qty;
    const lineCompare = item.compareAtPrice * item.qty;
    row.querySelector('.js-bundle-item-price-sale').textContent = formatMoney(linePrice);

    const compareEl = row.querySelector('.js-bundle-item-price-compare');
    if (lineCompare > linePrice) {
      compareEl.textContent = formatMoney(lineCompare);
      compareEl.hidden = false;
    }

    const badgeEl = row.querySelector('.js-bundle-item-price-badge');
    if (badgeEl && complete && lineCompare > linePrice) {
      const pct = Math.round(((lineCompare - linePrice) / lineCompare) * 100);
      const template = badgeEl.dataset.template || '%{pct}% off';
      badgeEl.textContent = template.replace('%{pct}', String(pct));
      badgeEl.hidden = pct <= 0;
    }

    // Conditional colour / size, with the separator only when both exist.
    const hasColor = Boolean(item.color);
    const hasSize = Boolean(item.size);
    if (hasColor) {
      row.querySelector('.js-bundle-item-color-value').textContent = item.color;
      row.querySelector('.js-bundle-item-color').hidden = false;
    }
    if (hasSize) {
      row.querySelector('.js-bundle-item-size-value').textContent = item.size;
      row.querySelector('.js-bundle-item-size').hidden = false;
    }
    row.querySelector('.js-bundle-item-option-sep').hidden = !(hasColor && hasSize);

    row.querySelector('.js-bundle-item-qty-value').textContent = item.qty;

    return row;
  }

  // Replace all rows in one go so there's no empty-then-filled flash.
  function renderStep(step) {
    const list = document.querySelector(
      '.js-bundle-drawer-items[data-step="' + step + '"]'
    );
    if (!list) return;

    const state = window.BuildABundleState.getState();
    const items = state[step] || [];

    list.replaceChildren.apply(
      list,
      items.map((item) => buildItemRow(item, step))
    );
    list.hidden = items.length === 0;
  }

  // Rebuild all steps — completeness changes pricing on every row.
  function onItemsStateChanged() {
    ['harnesses', 'dildos', 'addons'].forEach(renderStep);
  }

  function initItemRows() {
    if (!document.querySelector('.js-bundle-item-row-template')) return;

    if (window.BuildABundleState) {
      onItemsStateChanged({});
      window.BuildABundleState.subscribe('build-a-bundle:state-changed', onItemsStateChanged);
    } else {
      document.addEventListener(
        'build-a-bundle:hydrated',
        () => {
          onItemsStateChanged({});
          window.BuildABundleState.subscribe('build-a-bundle:state-changed', onItemsStateChanged);
        },
        { once: true }
      );
    }
  }

  /* Item controls — delegated qty +/- and Remove */

  function initItemControls() {
    const drawer = document.querySelector('.js-bundle-drawer');
    if (!drawer) return;

    drawer.addEventListener('click', (e) => {
      const row = e.target.closest('.js-bundle-item-row');
      if (!row) return;

      const step = row.dataset.step;
      const variantId = Number(row.dataset.variantId);
      const item = (window.BuildABundleState.getState()[step] || []).find(
        (i) => i.variantId === variantId
      );
      if (!item) return;

      if (e.target.closest('.js-bundle-item-qty-up')) {
        window.BuildABundleState.updateQty(step, variantId, item.qty + 1);
      } else if (e.target.closest('.js-bundle-item-qty-down')) {
        window.BuildABundleState.updateQty(step, variantId, item.qty - 1);
      } else if (e.target.closest('.js-bundle-item-remove')) {
        window.BuildABundleState.removeItem(step, variantId);
      }
    });
  }

  /* When to show the summary footer.
       Mobile: empty → hidden; partial → Total only;
         complete → Total, original price struck through, % off badge, CTA.
       Desktop: always visible so the CTA stays put — greyed out and disabled
         until the required steps are done, then it turns on. The Total row
         still only shows once there are items. */

  const SUMMARY_DESKTOP_MQ = window.matchMedia('(min-width: 990px)');

  function syncSummary() {
    const footer = document.querySelector('.js-bundle-summary');
    if (!footer) return;
    const drawer = document.querySelector('.js-bundle-drawer');

    const S = window.BuildABundleState;
    const state = S.getState();
    const hasItems =
      state.harnesses.length + state.dildos.length + state.addons.length > 0;
    const complete = S.isComplete();
    const isDesktop = SUMMARY_DESKTOP_MQ.matches;

    // Mobile collapses the footer when empty; desktop always shows it.
    if (!hasItems && !isDesktop) {
      footer.hidden = true;
      if (drawer) drawer.style.setProperty('--bundle-summary-h', '0px');
      return;
    }
    footer.hidden = false;

    const total = S.getDiscountedTotal();
    footer.querySelector('.js-bundle-summary-total').textContent = formatMoney(total);
    footer.dataset.complete = complete ? 'true' : 'false';

    const totalRow = footer.querySelector('.build-a-bundle__summary-row');
    const compareEl = footer.querySelector('.js-bundle-summary-compare');
    const badgeEl = footer.querySelector('.js-bundle-summary-badge');
    const ctaEl = footer.querySelector('.js-bundle-summary-cta');

    // Don't render Total when bundle has no items.
    if (totalRow) totalRow.hidden = !hasItems;

    if (complete) {
      const compareAtTotal = S.getCompareAtTotal();
      compareEl.textContent = formatMoney(compareAtTotal);
      compareEl.hidden = false;

      const pct =
        compareAtTotal > 0
          ? Math.round(((compareAtTotal - total) / compareAtTotal) * 100)
          : 0;
      const template = badgeEl.dataset.template || '%{pct}% off';
      badgeEl.textContent = template.replace('%{pct}', String(pct));
      badgeEl.hidden = pct <= 0;
    } else {
      compareEl.hidden = true;
      badgeEl.hidden = true;
    }

    // CTA: mobile shows it only when complete. Desktop always shows it,
    // disabled and dimmed until the required steps are complete.
    if (isDesktop) {
      ctaEl.hidden = false;
      ctaEl.disabled = !complete;
    } else {
      ctaEl.hidden = !complete;
      ctaEl.disabled = false;
    }

    // Save the footer's height so the drawer's max-height math accounts for it.
    if (drawer) {
      drawer.style.setProperty('--bundle-summary-h', footer.offsetHeight + 'px');
    }
  }

  function initSummary() {
    if (!document.querySelector('.js-bundle-summary')) return;

    if (window.BuildABundleState) {
      syncSummary();
      window.BuildABundleState.subscribe('build-a-bundle:state-changed', syncSummary);
    } else {
      document.addEventListener(
        'build-a-bundle:hydrated',
        () => {
          syncSummary();
          window.BuildABundleState.subscribe('build-a-bundle:state-changed', syncSummary);
        },
        { once: true }
      );
    }

    // Re-render when crossing the desktop/mobile breakpoint so the footer and
    // CTA update even if the bundle hasn't changed.
    SUMMARY_DESKTOP_MQ.addEventListener('change', () => {
      if (window.BuildABundleState) syncSummary();
    });
  }

  /* Summary CTA — collect the items, add to cart, clear on success */

  function buildAtcItems(state, bundleId, bundleName) {
    const all = state.harnesses.concat(state.dildos, state.addons);
    const totalQty = all.reduce((sum, item) => sum + item.qty, 0);
    const bundleKey =
      Date.now() + '-' + Math.random().toString(36).slice(2, 8);

    return all.map((item) => ({
      id: item.variantId,
      quantity: item.qty,
      properties: {
        _bundle_id: bundleId,
        _bundle_name: bundleName,
        _bundle_key: bundleKey,
        _bundle_size: String(totalQty),
      },
    }));
  }

  function setCtaLoading(cta, loading) {
    const label = cta.querySelector('.js-bundle-summary-cta-label')
      || cta.querySelector('.build-a-bundle__summary-cta-label');
    if (loading) {
      cta.classList.add('is-loading');
      cta.disabled = true;
      if (label) {
        label.dataset.originalText = label.textContent;
        const adding = cta.dataset.labelAdding;
        if (adding) label.textContent = adding;
      }
    } else {
      cta.classList.remove('is-loading');
      cta.disabled = false;
      if (label && label.dataset.originalText) {
        label.textContent = label.dataset.originalText;
        delete label.dataset.originalText;
      }
    }
  }

  function initSummaryCta() {
    const cta = document.querySelector('.js-bundle-summary-cta');
    const root = document.querySelector('.js-bundle-root');
    if (!cta || !root) return;

    const bundleId = root.dataset.bundleId || '';
    const bundleName = root.dataset.bundleName || '';

    cta.addEventListener('click', async () => {
      const S = window.BuildABundleState;
      if (!S || !S.isComplete()) return;

      const items = buildAtcItems(S.getState(), bundleId, bundleName);
      if (items.length === 0) return;

      setCtaLoading(cta, true);

      try {
        await window.wfhBundleAtc.submit(items);

        // Nudge the bundle-discount app to re-evaluate the cart.
        if (
          window.bndlr &&
          typeof window.bndlr.updateCartDiscounts === 'function'
        ) {
          window.bndlr.updateCartDiscounts();
        }

        if (closeDrawerIfOpen) closeDrawerIfOpen();
        S.clear();
      } catch (error) {
        console.error('[build-a-bundle] add to cart failed', error);
      } finally {
        setCtaLoading(cta, false);
      }
    });
  }

  initBar();
  initDrawerToggle();
  initDrawerPills();
  initItemRows();
  initItemControls();
  initSummary();
  initSummaryCta();
})();
